import { NgModule } from '@angular/core';
import { CustomerRoutingModule } from './customer-routing.module';
import { provideConfig } from 'core/config';
import { SelfOnboardCustomerRoutingModule } from './pages/customers/self-onboard-customer/self-onboard-customer-routing.module';
@NgModule({
  imports: [CustomerRoutingModule, SelfOnboardCustomerRoutingModule],
  providers: [
    provideConfig({
      api: {
        endpoints: {
          customersListCustomer: 'customers',
          customersGetCustomer: 'customer/${customerId}',
          customersUpdateCustomer: 'customer/${customerId}',
          // The profile's maintained lookup lists — payment terms today. Read
          // here so the editor can offer the distributor's own terms rather
          // than free text.
          customersProfileLookupValues:
            'admin/profile/${profileId}/lookups/${valueType}',
          customersDeleteCustomer: 'customer/${customerId}',
          customersMigratePreview: 'customer/${customerId}/migrate/preview',
          customersMigrate: 'customer/${customerId}/migrate',
          customersCreateCustomer: 'customer',
          customersPaymentMethods: 'customer/${customerId}/tokens',
          customersAchPaymentMethods: 'customer/${customerId}/achtokens',
          customersCreatePaymentMethod: 'customer/${customerId}/token',
          customersCreateAchPaymentMethod: 'customer/${customerId}/achToken',
          customersDeletePaymentMethod: 'customer/${customerId}/token/${paymentMethodId}',
          customersGetPaymentMethod: 'customer/${customerId}/token/${paymentMethodId}',
          customersSetDefaultPaymentMethod: 'customer/${customerId}/token/${paymentMethodId}/default',
          customersVerifyAchAccount: 'customer/${customerId}/token/${paymentMethodId}/verify',
          // customersCreateSelfOnboardLink: 'customer/selfonboard',
          // customersGetSelfOnboardLink: 'customer/selfonboard/link/${linkId}',
          // customersCreateSelfOnboard: {
          //   path: 'customer/selfonboard/link/${linkId}',
          //   auth: false
          // },
          customersCreateSelfOnboardLink: 'customer/selfonboard',
          customersGetSelfOnboardLink: 'customer/selfonboard/link/${linkId}',
          customersCreateSelfOnboard: {
            path: 'customer/selfonboard/link/${linkId}',
            auth: false,
          },
          selfOnboardGetTokens: {
            path: 'customer/selfonboard/link/${linkId}/tokens',
            auth: false,
          },
          selfOnboardAddToken: {
            path: 'customer/selfonboard/link/${linkId}/tokens',
            auth: false,
          },
          selfOnboardDeleteToken: {
            path: 'customer/selfonboard/link/${linkId}/tokens/${tokenId}',
            auth: false,
          },
          selfOnboardSetDefaultToken: {
            path: 'customer/selfonboard/link/${linkId}/tokens/${tokenId}/default',
            auth: false,
          },
          selfOnboardValidatePayment: {
            path: 'customer/selfonboard/link/${linkId}/validate',
            auth: false,
          },
          customersGetAllTokens: 'tokens',
          customersUpdatePaymentToken: 'customer/${customerId}/paymentToken/${paymentMethodId}',

          // Invoice endpoints
          customersGetInvoices: 'customers/${customerId}/invoices',
          customersArSummary: 'invoices/customer-ar-summary',
          customerDetailSummary: 'invoices/customer-summary/${customerId}',
          customerInvoiceTypes: 'invoices/customer-types/${customerId}',
          customersApplyCredits: 'customers/${customerId}/credit-applications',
          customerAvailableCredits: 'customers/${customerId}/available-credits',
          customerBalanceEntries: 'customers/${customerId}/balance-entries',
          customerBalanceEntryReverse: 'customers/${customerId}/balance-entries/${ledgerId}/reverse',
          customerInvoicesPaged: 'invoices',
          customersAddTestInvoices: 'customers/${customerId}/invoices',
          getInvoiceById: 'invoices/${invoiceRef}',
          getInvoiceEvents: 'invoices/${invoiceRef}/events',
          getInvoiceMetadata: 'invoices/${invoiceRef}/metadata',

          // Customer ledger (read-only statement history + derived position)
          customerLedger: 'customers/${customerId}/ledger',
          customerLedgerSummary: 'customers/${customerId}/ledger/summary',
          customerLedgerEntry: 'customer-ledger/entries/${ledgerId}',
          customerLedgerSummaries: 'customer-ledger/summaries',

          // Customer Portal User endpoints
          customersGetPortalUsers: 'customer/${customerId}/users',
          customersGetPortalUser: 'customer/${customerId}/user/${userNumber}',
          customersCreatePortalUser: 'customer/${customerId}/user',
          customersUpdatePortalUser: 'customer/${customerId}/user/${userNumber}',
          customersDeletePortalUser: 'customer/${customerId}/user/${userNumber}',
          customersResetPortalUserPassword: 'customer/${customerId}/user/${userNumber}/resetPassword',
          customersGetPortalUserRoles: 'customer/${customerId}/user/${userNumber}/roles',
          customersSetPortalUserRoles: 'customer/${customerId}/user/${userNumber}/roles',

          // CSV column-mapping endpoints (shared with payment module; duplicated here
          // so the customer wizard works regardless of module load order)
          csvMappingGet: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingSave: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingDelete: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingList: 'csv-mappings/${mappingType}',
          csvMappingVersions: 'csv-mappings/${mappingType}/${mappingName}/versions',
          
          // FlashPay onboarding: multi-invoice PDF parse
          flashpayParseInvoiceBatch: 'flashpay/parse-invoice-batch',

          // Campaign endpoints
          campaignsCreate: 'campaigns',
          campaignsList: 'campaigns',
          campaignSave: 'campaigns/save',
          campaignGet: 'campaigns/${campaignId}',
          campaignUpdate: 'campaigns/${campaignId}',
          campaignStart: 'campaigns/${campaignId}/start',
          campaignEnd: 'campaigns/${campaignId}/end',
          campaignRemind: 'campaigns/${campaignId}/remind',

          // Campaign email template endpoints (CREATE_CUSTOMER scoped)
          campaignEmailTemplateTypes: 'campaigns/email-templates/types',
          campaignEmailTemplate: 'campaigns/email-templates/${templateType}',
          campaignEmailTemplatePreview: 'campaigns/email-templates/preview',
        },
      },
    }),
  ],
})
export class CustomerModule {}
